/**
 * Copyright (c) Aleksei Volkov and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
import moment, { utc } from 'moment';

export const deepCopyObject = (obj = {}) => JSON.parse(JSON.stringify(obj))

export const parseJson = (str, defaultValue = null) => {
  try {
    return JSON.parse(str)
  } catch (e) {
    return defaultValue
  }
}

export function generateUuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const toDate = dateStr => {
  if (dateStr) {
    const [day, month, year] = dateStr?.split('.')
    return new Date(year, month - 1, day) || null
  }
  return null
}

export const hasRole = (roles = [], user = {}, key = 'roles') => {
  if (!user || !user?.[key]) {
    return false
  }
  if (Array.isArray(roles) && roles?.length === 0) {
    return true
  }
  return (
    Array.isArray(roles) &&
    !!roles?.find(
      ({ code: roleCode, project: projectCode }) =>
        !!user?.[key]?.find(
          ({ code, project }) =>
            code === roleCode && project.code === projectCode
        )
    )
  )
}

export const hasRoleByCode = (role = '', user = {}, key = 'roles') => {
  if (!user || !user?.[key] || !role) {
    return false
  }

  return !!user?.[key]?.some(({ code }) => code === role)
}

export const hasRoleById = (
  projectCode = '',
  role = '',
  user = {},
  key = 'roles'
) => {
  if (!user || !user?.[key] || !projectCode || !role) {
    return false
  }
  return user[key].some(
    item => item.code === role && item.project?.code === projectCode
  )
}

export const getFomattedDate = (date) => moment(date).format('hh:mm, DD.MM.YYYY')

export const getFormattedFiltersDate = (date) => {
  if(moment(date).format('DD.MM.YYYY') === 'Invalid date')
    return date;

  return moment(date).format('DD.MM.YYYY')
}

export const getStatusColor = (status) => {
  switch(status) {
    case 'initial_call':
      return 'primaryStatus'
    case 'set_meeting':
      return 'yellow'
    case 'client_thinks':
      return 'yellowStatus'
    case 'accepted':
      return 'redOut'
    case 'declined':
      return 'black'
    default:
      return 'transparent'
  }
}

export const getCurrentDay = () => {
  let date = new Date()
  const year = date.getFullYear()
  const month = date.getMonth() + 1 <= 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  const day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()

  return [year, month, day,].join('-');
};

export const smartEnds = (n, w, o, s, m, full) => {
  if ((!!w || w === '') && (!!o || o === '') && (!!s || s === '') && (!!m || m === '') && (!!n || n === 0)) {
    n = n.toString()
    if ((n.length === 1 || n > 20) && ((n[n.length - 1]) === '1')) return n + (full ? '' : w) + o;
    if ((n.length === 1 || n > 20) && ((n[n.length - 1]) < 5 && n[n.length - 1] > 1)) return n + (full ? '' : w) + s;
    if (((n[n.length - 1]) > 4 || (n[n.length - 1]) === '0') ||(n > 4 && n < 21)) return n + (full ? '' : w) + m;
  } else {return n + w;}
}

export const dateDiff = (diff) => {
	if (!diff) { return diff }
	const times = {
		ss: !!parseInt(moment(diff).utc().format('ss')) ? smartEnds(parseInt(moment(diff).utc().format('ss')), ' секунд', 'а', 'ы', '') : '',
		mm: !!parseInt(moment(diff).utc().format('mm')) ? smartEnds(parseInt(moment(diff).utc().format('mm')), ' минут', 'а', 'ы', '') + ' ' : '',
		HH: !!(parseInt(moment(diff).utc().format('HH'))) ? smartEnds(parseInt(moment(diff).utc().format('HH')) , ' час', '', 'а', 'ов') + ' ' : '',
		DD: !!(parseInt(moment(diff).utc().format('DD')) - 1) ? smartEnds(parseInt(moment(diff).utc().format('DD')) - 1, ' день', ' день', ' дня', 'дней', true) + ' ' : '',
		MM: !!(parseInt(moment(diff).utc().format('MM')) - 1) ? smartEnds(parseInt(moment(diff).utc().format('MM')) - 1, ' месяц', '', 'а', 'ев') + ' ' : ''
	}
	if (diff < 60000) {
		return ((times.ss || ''));
	}
	if (diff < 3600000) {
		return ((times.mm || ''));
	}
	if (diff < 86400000) {
		return ((times.HH || '') + (times.mm || ''));
	}
	if (!(parseInt(moment(diff).utc().format('MM')) - 1)) {
		return ((times.DD || '') + (times.HH || '') + (times.mm || ''));
	}
	return ((times.MM || '') + (times.DD || '') + (times.HH || '') + (times.mm || ''));
}

export const deepCopyArrayOfObjects = (arr) => {
  let newArray = [];

  arr.forEach((obj) => {
    let newObj = Object.assign({}, obj);
    newArray.push(newObj);
  });

  return newArray
}
